import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/molecules/header/Header";
import Titulo from "../../components/atoms/titles/Titulo";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import Footer from "../../components/molecules/footer/Footer";
import { useNavigate } from "react-router-dom";
import { getSolicitudPDFConcursos } from "../../components/services/ConcursosService";
const DescargarSolicitudConcurso = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true); // de momento hasta que se traigan las cosas bien
  const [solicitud, setSolicitud] = useState("");
  
  
//   copiar llamada con esta peticion al pdf de dani
  useEffect(() => {
  
    getSolicitudPDFConcursos(params?.idCon,  params?.idSol).then((data) => {
      
      if (!data.toString().startsWith("Error:")) {
        var reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = function () {
          var base64data = reader.result;
          
          setSolicitud(base64data);
          setLoading(true);
        };
      }
    });
  }, [params?.id, params?.idCon, params?.idSol]);
  return (
    <>
      <Header></Header>
      <div className="container d-flex flex-column card mt-5" id="inicio" role="main" data-landmark-index="4">
        {loading ? (
          <>
            <div className="my-auto">
              <div className="container-login fondo">
                <div className="tituloSolicitud">
                  <div className="d-flex align-items-center flex-column">
                    {/* <Titulo
                      titulo={"Acto S1 Variación de datos personales"}
                      tipo={"tituloPagina subTituloPagina"}
                    /> */}
                    {/* <p className="text-third-1">{datos.estado}</p> */}
                  </div>
                  <div className="datosPersonalesCarrera d-flex flex-column m-2">
                    <div>
                      <div className="d-flex justify-content-between">
                        <Titulo
                          clases={"subSubTituloSolicitud p-2 fw-bold"}
                          tipo={"tituloCard noBg"}
                          titulo={"Descargar - "+params?.idSol}
                        ></Titulo>
                      </div>
                      <div className="separador"></div>
                    </div>

                    <div className="formulario">
                      <>
                        <div className="m-2"></div>
                        <div className="m-3 card scroll-list container-list-border">
                          <div className="gridPresentar">
                            <div className="iframePresentar pt-3">
                              <object
                                data={solicitud}
                                type="application/pdf"
                                height="500"
                                width="100%"
                                aria-label="PDF del borrador"
                                className="rounded"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                      <div className="gridBotones mb-2">
                        <button
                          id="volver"
                          className="btnRed rounded btnCancelarDocumentacion"
                          type="button"
                          onClick={() => navigate("/concurso/"+params?.idCon)}
                        >
                          <i className="fa-solid fa-rotate-left"></i> Volver
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto">
              <SpinnerCircle></SpinnerCircle>
            </div>
          </>
        )}
      </div>
      <Footer></Footer>
    </>
  );
};
export default DescargarSolicitudConcurso;
